// The searchrefiner backend (hscells/transmute) matches field tags case-sensitively
// and silently falls back to [All Fields] for any spelling it does not know
// (e.g. [Mesh terms], [MeSH terms], [MH], [TIAB], [title/abstract]).
// Map any casing of a known tag to a spelling the backend recognises.
const canonicalFields = [
	// MeSH headings
	"mesh",
	"mesh terms",
	"mh",
	"mesh headings",
	// Major focus MeSH
	"mesh major topic",
	"majr",
	// Subheadings
	"subheading",
	"sh",
	"MeSH Subheading",
	// Title / abstract / text
	"tiab",
	"Title/Abstract",
	"ti",
	"Title",
	"Abstract",
	"tw",
	"Text Word",
	"text",
	"All Fields",
	// Publication
	"pt",
	"Publication Type",
	"Publication Date",
	"sb",
	"Journal",
	"Publisher",
	"Language",
	// Authors
	"Author",
	"Author - Corporate",
	"Author - First",
	"Author - Full",
	"Author - Identifier",
	"Author - Last",
	"Affiliation",
	"Investigator",
	"Investigator - Full",
	"Editor",
	// Dates
	"Date - Completion",
	"Date - Create",
	"Date - Entrez",
	"Date - MeSH",
	"Date - Modification",
	"Date - Publication",
	// Other
	"Book",
	"Conflict of Interest Statements",
	"EC/RN Number",
	"Filter",
	"Grant Number",
	"ISBN",
	"Issue",
	"Location ID",
	"Other Term",
	"Pagination",
	"Pharmacological Action",
	"Secondary Source ID",
	"Subject - Personal Name",
	"Supplementary Concept",
	"Transliterated Title",
	"Volume"
];

// Aliases the backend does not know at all, mapped to an equivalent it does
const aliases = {
	"title/abstract": "tiab",
	"mesh term": "mesh terms",
	"mesh heading": "mesh"
};

const fieldLookup = {};
canonicalFields.forEach(field => {
	fieldLookup[field.toLowerCase()] = field;
});
Object.keys(aliases).forEach(alias => {
	fieldLookup[alias] = aliases[alias];
});

export default function normalizeFields(query) {
	return query.replace(/\[([^\]]*)\]/g, (match, tag) => {
		const key = tag.trim().replace(/\s+/g, " ").toLowerCase();
		// The backend lower-cases tags with :noexp itself, so only tidy whitespace
		if (key.includes(":noexp")) {
			return `[${key}]`;
		}
		return fieldLookup[key] ? `[${fieldLookup[key]}]` : match;
	});
}
